import React from 'react'
import { useTranslation } from 'react-i18next'

import { ChartBox } from './ChartBox'

import { RF } from '../constants'

interface IGraphResultRowProps {
  cumulativeAmount: number
  estimatedAmount: number
}

const MIN_PERCENT = 33

const GraphResultRow = ({
  cumulativeAmount,
  estimatedAmount,
}: IGraphResultRowProps) => {
  const { t } = useTranslation()

  const getPercent = () => {
    const percent = (cumulativeAmount / estimatedAmount) * 100
    if (percent < MIN_PERCENT) {
      return MIN_PERCENT + '%'
    }

    return percent + '%'
  }

  return (
    <div className='csas-result-inner'>
      <div className='csas-bar-chart-section'>
        <ChartBox
          value={Math.round(cumulativeAmount)}
          label={t('RESULT.CUMULATIVE_VALUE')}
          percent={getPercent()}
          rf={RF.CUMULATIVE}
          unit={t('CZK')}
        />
        <ChartBox
          value={Math.round(estimatedAmount)}
          label={t('RESULT.ESTIMATED_VALUE')}
          percent={'100%'}
          rf={RF.ESTIMATE}
          unit={t('CZK')}
          dark
        />
      </div>
    </div>
  )
}

export { GraphResultRow }
